/* eslint-disable prefer-destructuring */
export const ELOQUA_URL = process.env.ELOQUA_URL;
export const CAMPAIGN_ID_COMMUNITY = '7010H000001el61';
export const PRIVACY_URL = `${process.env.PRIVACY_URL}`;
export default ELOQUA_URL;

export const MARKETO_CAMPAIGN_ID = `${process.env.MARKETO_CAMPAIGN_ID}` || '7012K000001qP4yQAE';
export const LEAD_SOURCE_COMMUNITY = 'Community';
export const MARKETO_UPGRADE_FORM = 'MARKETO_UPGRADE_FORM';
export const MARKETO_FORM_URL = '//app-ab29.marketo.com';
export const MARKETO_SCRIPT_URL = 'https://app-ab29.marketo.com/js/forms2/js/forms2.min.js';
export const MARKETO_FORM_MUNCHKIN_ID = '732-GKV-655';
export const MARKETO_FORM_ID = '6478';
